import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

// Register required components and plugins
ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const GenericDoughnutChart = ({
  labels,
  data,
  backgroundColors,
  tooltipCallback,
}) => {
  return (
    <Doughnut
      data={{
        labels,
        datasets: [
          {
            data,
            backgroundColor: backgroundColors,
            borderWidth: 0,
          },
        ],
      }}
      options={{
        layout: {
          padding: {
            bottom: 20,
          },
        },
        plugins: {
          tooltip: {
            callbacks: {
              label: tooltipCallback,
            },
          },
          datalabels: {
            formatter: function () {
              return '';
            },
            anchor: 'center',
            align: 'right',
            clamp: false,
            color: '#ffffff',
            font: {
              weight: 'bold',
              size: 12,
            },
          },
          legend: {
            display: true,
            labels: {
              padding: 10,
              boxWidth: 10,
              boxHeight: 10,
              boxPadding: 0,
            },
            align: 'center',
            fullSize: true,
            position: 'left',
            textDirection: 'rtl',
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            display: false,
            grid: {
              color: 'rgba(0, 0, 0, 0)',
            },
          },
          x: {
            display: false,
            grid: {
              color: 'rgba(0, 0, 0, 0)',
            },
          },
        },
      }}
    />
  );
};

export default GenericDoughnutChart;
